import * as React from "react";
import Dialog from "../../components/Dialog";
import { GamesBackground, GamesButton, GamesSubtitle, GamesTitle } from "./style";
class GamesRedeem extends React.PureComponent {
    render() {
        const { show, onClose, onEnter } = this.props;
        return (React.createElement(Dialog, { show: show, isAutoFixedBody: true, style: { background: "rgba(0, 0, 0, 0.8)" } },
            React.createElement(GamesBackground, null,
                React.createElement(GamesTitle, null, "Successfully!"),
                React.createElement(GamesSubtitle, null, "You have gotten a free dice")),
            React.createElement(GamesButton, { onClick: onEnter }, "Back to game"),
            React.createElement(GamesButton, { onClick: onClose }, "Stay here")));
    }
}
export default GamesRedeem;
